var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLangWorld(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon_set"
  }, /*#__PURE__*/React.createElement("path", {
    id: "icon_vector",
    d: "M11.99 1.99997C6.47 1.99997 2 6.47997 2 12C2 17.52 6.47 22 11.99 22C17.52 22 22 17.52 22 12C22 6.47997 17.52 1.99997 11.99 1.99997ZM18.92 7.99997H15.97C15.65 6.74997 15.19 5.54997 14.59 4.43997C16.43 5.06997 17.96 6.34997 18.92 7.99997ZM12 4.03997C12.83 5.23997 13.48 6.56997 13.91 7.99997H10.09C10.52 6.56997 11.17 5.23997 12 4.03997ZM4.26 14C4.1 13.36 4 12.69 4 12C4 11.31 4.1 10.64 4.26 9.99997H7.64C7.56 10.66 7.5 11.32 7.5 12C7.5 12.68 7.56 13.34 7.64 14H4.26ZM5.08 16H8.03C8.35 17.25 8.81 18.45 9.41 19.56C7.57 18.93 6.04 17.66 5.08 16ZM8.03 7.99997H5.08C6.04 6.33997 7.57 5.06997 9.41 4.43997C8.81 5.54997 8.35 6.74997 8.03 7.99997ZM12 19.96C11.17 18.76 10.52 17.43 10.09 16H13.91C13.48 17.43 12.83 18.76 12 19.96ZM14.34 14H9.66C9.57 13.34 9.5 12.68 9.5 12C9.5 11.32 9.57 10.65 9.66 9.99997H14.34C14.43 10.65 14.5 11.32 14.5 12C14.5 12.68 14.43 13.34 14.34 14ZM14.59 19.56C15.19 18.45 15.65 17.25 15.97 16H18.92C17.96 17.65 16.43 18.93 14.59 19.56ZM16.36 14C16.44 13.34 16.5 12.68 16.5 12C16.5 11.32 16.44 10.66 16.36 9.99997H19.74C19.9 10.64 20 11.31 20 12C20 12.69 19.9 13.36 19.74 14H16.36Z",
    fill: "#DD5800"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLangWorld);
export default __webpack_public_path__ + "static/media/lang_world.821a039e9a0200235f04aaff4ede0172.svg";
export { ForwardRef as ReactComponent };